<template>
  <v-dialog v-model="isOpen" max-width="500px" @update:modelValue="onDialogToggle">
    <v-card>
      <v-card-title>Edit Company</v-card-title>
      <v-card-text>

        <v-text-field
          v-model="form.name"
          label="Company Name"
          :error-messages="nameError"
          :class="{ 'shake-animation': shakeName }"
          @input="nameError = ''"
        ></v-text-field>

        <!-- Show existing icon if present -->
        <div v-if="existingIconUrl && !form.icon" class="existing-icon-preview">
          <span class="icon-label">Current Icon:</span>
          <img :src="existingIconUrl" alt="Current company icon" class="icon-preview-img" />
        </div>

        <v-file-input
          v-model="form.icon"
          label="Upload New Company Icon"
          accept="image/*"
          clearable
        ></v-file-input>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel">Cancel</v-btn>
        <v-btn text color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
  name: 'OwnerAccountEditCompany',

  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    company: {
      type: Object,
      required: true
    }
  },

  emits: ['update:modelValue', 'saved'],

  data() {
    return {
      form: {
        name: '',
        icon: null
      },
      nameError: '',
      shakeName: false,
      saving: false,
      existingIconUrl: ''
    };
  },

  computed: {
    isOpen: {
      get() { return this.modelValue; },
      set(val) { this.$emit('update:modelValue', val); }
    }
  },

  watch: {
    // Populate form whenever the dialog opens with a new company
    modelValue(opened) {
      if (opened && this.company) {
        this.form.name = this.company.name || '';
        this.form.icon = null;
        this.existingIconUrl = this.company.icon || '';
        this.nameError = '';
      }
    }
  },

  methods: {
    onDialogToggle(val) {
      if (!val) this.resetForm();
    },

    resetForm() {
      this.form = { name: '', icon: null };
      this.nameError = '';
      this.shakeName = false;
      this.saving = false;
    },

    cancel() {
      this.isOpen = false;
    },

    triggerShake(field) {
      this[field] = true;
      setTimeout(() => { this[field] = false; }, 500);
    },

    async save() {
      // Validate
      if (!this.form.name.trim()) {
        this.nameError = 'Company name is required';
        this.triggerShake('shakeName');
        return;
      }

      this.saving = true;
      try {
        const formData = new FormData();
        formData.append('name', this.form.name.trim());
        if (this.form.icon) {
          formData.append('icon', this.form.icon);
        }

        const response = await axios.put(
          `${process.env.VUE_APP_THIS_SERVER}/portaldb/db/companies/${this.company._id}`,
          formData
        );

        this.$emit('saved', response.data.company);
        this.isOpen = false;
      } catch (error) {
        console.error('Error saving company:', error);
        this.nameError = 'Failed to save. Please try again.';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.existing-icon-preview {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.icon-label {
  font-size: 14px;
  color: #666;
}

.icon-preview-img {
  width: 50px;
  height: 50px;
  object-fit: contain;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.shake-animation {
  animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
}

@keyframes shake {
  10%, 90% { transform: translate3d(-1px, 0, 0); }
  20%, 80% { transform: translate3d(2px, 0, 0); }
  30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
  40%, 60% { transform: translate3d(4px, 0, 0); }
}
</style>
